import React from 'react'

import { classNames } from '@lib/simpleFn'

type ChoiceNumberButtonProps = {
  questionNumber: number
  choiceNumber: number
  afterChoiceBorderTextBgStyle?: string
  clickHandler: () => void
  buttonClassName: string
  buttonBackgroundClassName: string
}

const ChoiceNumberButton: React.FC<ChoiceNumberButtonProps> = ({
  questionNumber,
  choiceNumber,
  afterChoiceBorderTextBgStyle,
  clickHandler,
  buttonClassName,
  buttonBackgroundClassName,
}) => {
  return (
    <div className={buttonBackgroundClassName}>
      <button
        className={classNames(
          'choice-number-circle rounded-full border flex justify-center items-center',
          afterChoiceBorderTextBgStyle
            ? afterChoiceBorderTextBgStyle
            : 'border-cbtLayout text-cbtLayout'
        )}
        id={`mainQa${questionNumber}${choiceNumber}`}
        onClick={clickHandler}
      >
        {/* <div className={'items-center text-center'}> */}
        <span className={classNames('choice-number translate-y', buttonClassName)}>
          {choiceNumber}
        </span>
        {/* </div> */}
      </button>
    </div>
  )
}

export default React.memo(ChoiceNumberButton)
